import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Heading,
  Button,
  Text,
  Link,
  VStack,
  Divider,
  Image
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';

const LoginConductor = () => {
  const { t } = useTranslation();
  const [allowGoogleLogin, setAllowGoogleLogin] = useState(false);
  const [allowTiktokLogin, setAllowTiktokLogin] = useState(false);
  const [allowInstagramLogin, setAllowInstagramLogin] = useState(false);
  const [allowFacebookLogin, setAllowFacebookLogin] = useState(false);

  const oauthIconByProvider = {
    google: '/assets/RRSS/google_color.svg',
    facebook: '/assets/RRSS/facebook_color.png',
    instagram: '/assets/RRSS/instagram_color.svg',
    tiktok: '/assets/RRSS/tiktok_color.svg',
  };

  useEffect(() => {
    const fetchLoginProviders = async () => {
      try {
        const API_BASE_URL = getApiBaseUrl();
        const response = await fetch(`${API_BASE_URL}/api/settings/public/login-providers`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        setAllowGoogleLogin(Boolean(data?.permitir_login_google));
        setAllowTiktokLogin(Boolean(data?.permitir_login_tiktok));
        setAllowInstagramLogin(Boolean(data?.permitir_login_instagram));
        setAllowFacebookLogin(Boolean(data?.permitir_login_facebook));
      } catch (err) {
        console.error('[LOGIN CONDUCTOR] Error loading login providers:', err);
      }
    };

    fetchLoginProviders();
  }, []);

  const handleGoogleLogin = () => {
    const API_BASE_URL = getApiBaseUrl();
    window.location.href = `${API_BASE_URL}/api/auth/google?role=conductor`;
  };

  const handleFacebookLogin = () => {
    const API_BASE_URL = getApiBaseUrl();
    window.location.href = `${API_BASE_URL}/api/auth/facebook?role=conductor`;
  };

  const handleInstagramLogin = () => {
    const API_BASE_URL = getApiBaseUrl();
    window.location.href = `${API_BASE_URL}/api/auth/instagram?role=conductor`;
  };

  const handleTiktokLogin = () => {
    const API_BASE_URL = getApiBaseUrl();
    window.location.href = `${API_BASE_URL}/api/auth/tiktok?role=conductor`;
  };

  return (
    <Box p={4}>
      <Heading as="h2" size="lg" mb={4}>
        {t('login_titulo_conductor', { defaultValue: 'Entrar como conductor' })}
      </Heading>

      <VStack spacing={4} align="stretch">
        <Link as={RouterLink} to="/registro-conductor" color="blue.600" fontWeight="semibold">
          {t('login_registro_nuevo_conductor', { defaultValue: 'Registrarse como nuevo conductor' })}
        </Link>

        {(allowGoogleLogin || allowFacebookLogin || allowInstagramLogin || allowTiktokLogin) && (
          <>
            <Divider />
            <Text textAlign="center" color="gray.600">
              {t('login_multi_o')}
            </Text>

            {allowGoogleLogin && (
              <Button
                className="oauth-provider-button oauth-provider-google"
                onClick={handleGoogleLogin}
                leftIcon={<Image src={oauthIconByProvider.google} alt="Google" boxSize="18px" objectFit="contain" />}
              >
                {t('login_multi_google')}
              </Button>
            )}

            {allowFacebookLogin && (
              <Button
                className="oauth-provider-button oauth-provider-facebook"
                onClick={handleFacebookLogin}
                leftIcon={<Image src={oauthIconByProvider.facebook} alt="Facebook" boxSize="18px" objectFit="contain" />}
              >
                {t('login_multi_facebook')}
              </Button>
            )}

            {allowInstagramLogin && (
              <Button
                className="oauth-provider-button oauth-provider-instagram"
                onClick={handleInstagramLogin}
                leftIcon={<Image src={oauthIconByProvider.instagram} alt="Instagram" boxSize="18px" objectFit="contain" />}
              >
                {t('login_multi_instagram')}
              </Button>
            )}

            {allowTiktokLogin && (
              <Button
                className="oauth-provider-button oauth-provider-tiktok"
                onClick={handleTiktokLogin}
                leftIcon={<Image src={oauthIconByProvider.tiktok} alt="TikTok" boxSize="18px" objectFit="contain" />}
              >
                {t('login_multi_tiktok')}
              </Button>
            )}
          </>
        )}
      </VStack>
    </Box>
  );
};

export default LoginConductor;
